import React, { useEffect, useState } from 'react';
const cache = {};

// Function to resize the image by replacing the size part of the URL
const changeImageSize = (url, size) => {
  return url.replace(/100x100bb/, size + 'bb');
};

// Function to fetch data from iTunes API
const getData = async (artist, title, defaultArt, defaultCover) => {
  let text = artist === title ? title : `${artist} - ${title}`;
  const cacheKey = text.toLowerCase();

  // Check if the data is already in the cache
  if (cache[cacheKey]) {
    return cache[cacheKey];
  }

  try {
    // Fetch song data from the iTunes API
    const response = await fetch(`https://itunes.apple.com/search?limit=1&term=${encodeURIComponent(text)}`);
    if (response.status === 403) {
      // Handle forbidden response
      return {
        title,
        artist,
        art: defaultArt,
        cover: defaultCover,
        stream_url: '#not-found',
      };
    }

    // Process the response
    const data = response.ok ? await response.json() : {};
    
    if (!data.results || data.results.length === 0) {
      // Handle empty results
      return {
        title,
        artist,
        art: defaultArt,
        cover: defaultCover,
        stream_url: '#not-found',
      };
    }

    // Extract relevant information from the response
    const itunes = data.results[0];
    const results = {
      title: itunes.trackName || title,
      artist: itunes.artistName || artist,
      thumbnail: itunes.artworkUrl100 ? changeImageSize(itunes.artworkUrl100, '600x600') : defaultArt,
      art: itunes.artworkUrl100 ? changeImageSize(itunes.artworkUrl100, '600x600') : defaultArt,
      cover: itunes.artworkUrl100 ? changeImageSize(itunes.artworkUrl100, '1500x1500') : defaultCover,
      stream_url: '#not-found',
    };

    // Store the fetched results in the cache
    cache[cacheKey] = results;
    return results;
  } catch (error) {
    console.error('Error fetching data from iTunes:', error);
    // Fallback in case of an error
    return {
      title,
      artist,
      art: defaultArt,
      cover: defaultCover,
      stream_url: '#not-found',
    };
  }
};

// Custom React hook to fetch and manage song data
const useGetDataFromTunes = (songData) => {
  const [songImgData, setSongImgData] = useState(null);
  const [artist, title] = songData.split(" - ");

  useEffect(() => {
    const fetchData = async () => {
      const defaultArt = 'default-art-url';
      const defaultCover = 'default-cover-url';
      const result = await getData(artist, title, defaultArt, defaultCover);
      setSongImgData(result);
    };
    fetchData();
  }, [artist, title]);

  return songImgData;
};

export default useGetDataFromTunes;
